<!-- Hero Start -->
<section class="bg-half-170 d-table w-100 " id="home"
         style="background: url('assets/3r/cropped-4-sigiriya-sri-lanka-e1527283016873.jpg') center center;">
    <div class="bg-overlay"></div>
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-7 col-md-6">
                <div class="title-heading mt-4">
                    <h1 class="display-4 font-weight-bold text-white title-dark mb-3">Booking tour <br> made easy</h1>
                    <p class="para-desc text-white-50">We have long-standing relationships with all leading domestic air
                        travel operators in Sri Lanka, which helps us to be competitive in the market.</p>
                </div>
            </div>
        </div>
        <!--end row-->
    </div>
    <!--end container-->
</section>
<!--end section-->
<div class="position-relative ">
    <div class="shape overflow-hidden text-white">
        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
        </svg>
    </div>
</div>
<!-- Hero End -->

<div class="container mt-5 mb-3">
    <div class="row justify-content-center">
        <div class="col-12 text-center">
            <div class="section-title mb-4 pb-2">
                <h4 class="title mb-4">Our Services</h4>
            </div>
        </div>
        <!--end col-->
    </div>
    <!--end row-->

    <div class="row">

        <!--end col-->

        <div class="col-lg-3 col-md-4 mt-4 pt-2">
            <div
                    class="card features fea-primary rounded p-4 bg-light text-center position-relative overflow-hidden border-0">
           <span class="h1 icon2 text-primary">
             <i class="uil uil-thumbs-up"></i>
           </span>
                <div class="card-body p-0 content">
                    <h5>Easy Book</h5>
                    <p class="para text-muted mb-0">It is a long established fact that a reader.</p>
                </div>
                <span class="big-icon text-center">
             <i class="uil uil-thumbs-up"></i>
           </span>
            </div>
        </div>
        <!--end col-->

        <div class="col-lg-3 col-md-4 mt-4 pt-2">
            <div
                    class="card features fea-primary rounded p-4 bg-light text-center position-relative overflow-hidden border-0">
           <span class="h1 icon2 text-primary">
             <i class="uil uil-keyboard-show"></i>
           </span>
                <div class="card-body p-0 content">
                    <h5>Free Amenities</h5>
                    <p class="para text-muted mb-0">It is a long established fact that a reader.</p>
                </div>
                <span class="big-icon text-center">
             <i class="uil uil-keyboard-show"></i>
           </span>
            </div>
        </div>
        <!--end col-->

        <div class="col-lg-3 col-md-4 mt-4 pt-2">
            <div
                    class="card features fea-primary rounded p-4 bg-light text-center position-relative overflow-hidden border-0">
           <span class="h1 icon2 text-primary">
             <i class="uil uil-award"></i>
           </span>
                <div class="card-body p-0 content">
                    <h5>Best Offers</h5>
                    <p class="para text-muted mb-0">It is a long established fact that a reader.</p>
                </div>
                <span class="big-icon text-center">
             <i class="uil uil-award"></i>
           </span>
            </div>
        </div>
        <!--end col-->

        <div class="col-lg-3 col-md-4 mt-4 pt-2">
            <div
                    class="card features fea-primary rounded p-4 bg-light text-center position-relative overflow-hidden border-0">
           <span class="h1 icon2 text-primary">
             <i class="uil uil-bookmark"></i>
           </span>
                <div class="card-body p-0 content">
                    <h5>Cheap than Other</h5>
                    <p class="para text-muted mb-0">It is a long established fact that a reader.</p>
                </div>
                <span class="big-icon text-center">
             <i class="uil uil-bookmark"></i>
           </span>
            </div>
        </div>
        <!--end col-->


    </div>
    <!--end row-->
</div>
<!--end container-->

<section class=" mt-4">
    <div *ngIf="proPackages==null" class="row justify-content-center">
        <mat-spinner></mat-spinner>
    </div>
    <div class="container mt-3" *ngIf="proPackages!=null">
        <div class="row justify-content-center">
            <div class="col-12 text-center" *ngIf="proPackages.length!=0">
                <div class="section-title mb-4 pb-2" style="    margin-top: 2rem;">
                    <h4 class="title mb-4">Popular Packages</h4>
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->

        <div class="row">

            <div class="col-lg-12 col-md-6 mt-4">
                <owl-carousel-o [options]="customOptions">
                    <ng-template carouselSlide *ngFor="let p of proPackages" style="    padding-bottom: 25px;">
                        <!--                    <div class="media customer-testi m-2">-->
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-3">
                            <div class="card img shadow-md"
                                 style=" height:15rem; background-size: cover; background: url({{p.url}});border-radius: 10px">
                                <div class="bg-overlay" style="border-radius: 10px"></div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-12">
                                            <h4 style="color: white">{{p.packageName}}</h4>
                                            <!--                                    <p class="text-muted">He lay on his armour-like back, and if he lifted his head.</p>-->
                                        </div>
                                        <div class="col-12" style=" bottom: 10px;position: absolute;">
                                            <button class="btn btn-primary" style=" margin-top: 31px;"
                                                    (click)="booking(p)">
                                                book now
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--                    </div>-->
                    </ng-template>
                </owl-carousel-o>
            </div>
        </div>
        <!--end row-->
        <div *ngIf="proPackages.length!=0" class="col-lg-12 text-center col-md-4 mt-4 pt-2">
            <a href="javascript:void(0)" routerLink="/index-packages" class="btn btn-primary">See more
                <i-feather name="arrow-right" class="fea icon-sm"></i-feather>
            </a>
        </div>
    </div>
    <!--end container-->

</section>

<section class="section">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 text-center">
                <div class="section-title mb-4 pb-2">
                    <h4 class="title mb-4">Popular Destination</h4>
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->

        <div class="row">
            <div class="col-lg-4 col-md-6 mt-4 pt-2">
                <div class="card work-container work-modern rounded border-0 overflow-hidden">
                    <div class="card-body p-0">
                        <img src="assets/gallery/1.jpg" class="img-fluid rounded" alt="work-image">
                        <div class="overlay-work"></div>
                        <div class="read_more bg-primary text-center rounded-circle">
                            <a href="javascript:void(0)" class="text-light d-block">
                                <i-feather name="chevron-right" class="fea icon-sm title-dark"></i-feather>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!--end col-->

            <div class="col-lg-4 col-md-6 mt-4 pt-2">
                <div class="card work-container work-modern rounded border-0 overflow-hidden">
                    <div class="card-body p-0">
                        <img src="assets/gallery/2.jpg" class="img-fluid rounded" alt="work-image">
                        <div class="overlay-work"></div>
                        <div class="read_more bg-primary text-center rounded-circle">
                            <a href="javascript:void(0)" class="text-light d-block">
                                <i-feather name="chevron-right" class="fea icon-sm title-dark"></i-feather>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!--end col-->

            <div class="col-lg-4 col-md-6 mt-4 pt-2">
                <div class="card work-container work-modern rounded border-0 overflow-hidden">
                    <div class="card-body p-0">
                        <img src="assets/gallery/3.jpg" class="img-fluid rounded" alt="work-image">
                        <div class="overlay-work"></div>
                        <!--                            <div class="content">-->
                        <!--                                <a href="javascript:void(0)" class="title text-white pb-2 border-bottom">Deluxe Room</a>-->
                        <!--                                <ul class="post-meta mb-0 mt-2 text-white list-unstyled">-->
                        <!--                                    <li class="list-inline-item mr-3"><i class="mdi mdi-bed-empty mdi-24px mr-2"></i>1 Bed</li>-->
                        <!--                                    <li class="list-inline-item"><i class="mdi mdi-scale-bathroom mdi-24px mr-2"></i>2 Bathrooms</li>-->
                        <!--                                </ul>-->
                        <!--                                <p class="text-white d-block mb-0">Rent <span class="text-success">$1100</span> /Night</p>-->
                        <!--                            </div>-->
                        <div class="read_more bg-primary text-center rounded-circle">
                            <a href="javascript:void(0)" class="text-light d-block">
                                <i-feather name="chevron-right" class="fea icon-sm title-dark"></i-feather>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!--end col-->

            <div class="col-lg-4 col-md-6 mt-4 pt-2">
                <div class="card work-container work-modern rounded border-0 overflow-hidden">
                    <div class="card-body p-0">
                        <img src="assets/gallery/4.jpg" class="img-fluid rounded" alt="work-image">
                        <div class="overlay-work"></div>
                        <!--                            <div class="content">-->
                        <!--                                <a href="javascript:void(0)" class="title text-white pb-2 border-bottom">Super Deluxe Room</a>-->
                        <!--                                <ul class="post-meta mb-0 mt-2 text-white list-unstyled">-->
                        <!--                                    <li class="list-inline-item mr-3"><i class="mdi mdi-bed-empty mdi-24px mr-2"></i>2 Bed</li>-->
                        <!--                                    <li class="list-inline-item"><i class="mdi mdi-scale-bathroom mdi-24px mr-2"></i>2 Bathrooms</li>-->
                        <!--                                </ul>-->
                        <!--                                <p class="text-white d-block mb-0">Rent <span class="text-success">$1400</span> /Night</p>-->
                        <!--                            </div>-->
                        <div class="read_more bg-primary text-center rounded-circle">
                            <a href="javascript:void(0)" class="text-light d-block">
                                <i-feather name="chevron-right" class="fea icon-sm title-dark"></i-feather>

                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!--end col-->

            <div class="col-lg-4 col-md-6 mt-4 pt-2">
                <div class="card work-container work-modern rounded border-0 overflow-hidden">
                    <div class="card-body p-0">
                        <img src="assets/gallery/5%20(2).jpg" class="img-fluid rounded" alt="work-image">
                        <div class="overlay-work"></div>
                        <!--                            <div class="content">-->
                        <!--                                <a href="javascript:void(0)" class="title text-white pb-2 border-bottom">Deluxe Big Room</a>-->
                        <!--                                <ul class="post-meta mb-0 mt-2 text-white list-unstyled">-->
                        <!--                                    <li class="list-inline-item mr-3"><i class="mdi mdi-bed-empty mdi-24px mr-2"></i>3 Bed</li>-->
                        <!--                                    <li class="list-inline-item"><i class="mdi mdi-scale-bathroom mdi-24px mr-2"></i>3 Bathrooms</li>-->
                        <!--                                </ul>-->
                        <!--                                <p class="text-white d-block mb-0">Rent <span class="text-success">$1600</span> /Night</p>-->
                        <!--                            </div>-->
                        <div class="read_more bg-primary text-center rounded-circle">
                            <a href="javascript:void(0)" class="text-light d-block">
                                <i-feather name="chevron-right" class="fea icon-sm title-dark"></i-feather>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!--end col-->

            <div class="col-lg-4 col-md-6 mt-4 pt-2">
                <div class="card work-container work-modern rounded border-0 overflow-hidden">
                    <div class="card-body p-0">
                        <img src="assets/gallery/6%20(2).jpg" class="img-fluid rounded" alt="work-image">
                        <div class="overlay-work"></div>
                        <!--                            <div class="content">-->
                        <!--                                <a href="javascript:void(0)" class="title text-white pb-2 border-bottom">Family Room</a>-->
                        <!--                                <ul class="post-meta mb-0 mt-2 text-white list-unstyled">-->
                        <!--                                    <li class="list-inline-item mr-3"><i class="mdi mdi-bed-empty mdi-24px mr-2"></i>3 Bed</li>-->
                        <!--                                    <li class="list-inline-item"><i class="mdi mdi-scale-bathroom mdi-24px mr-2"></i>2 Bathrooms</li>-->
                        <!--                                </ul>-->
                        <!--                                <p class="text-white d-block mb-0">Rent <span class="text-success">$1750</span> /Night</p>-->
                        <!--                            </div>-->
                        <div class="read_more bg-primary text-center rounded-circle">
                            <a href="javascript:void(0)" class="text-light d-block">
                                <i-feather name="chevron-right" class="fea icon-sm title-dark"></i-feather>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!--end col-->

            <div class="col-lg-4 col-md-6 mt-4 pt-2">
                <div class="card work-container work-modern rounded border-0 overflow-hidden">
                    <div class="card-body p-0">
                        <img src="assets/gallery/7.jpg" class="img-fluid rounded" alt="work-image">
                        <div class="overlay-work"></div>
                        <!--                            <div class="content">-->
                        <!--                                <a href="javascript:void(0)" class="title text-white pb-2 border-bottom">Premium Room</a>-->
                        <!--                                <ul class="post-meta mb-0 mt-2 text-white list-unstyled">-->
                        <!--                                    <li class="list-inline-item mr-3"><i class="mdi mdi-bed-empty mdi-24px mr-2"></i>1 Bed</li>-->
                        <!--                                    <li class="list-inline-item"><i class="mdi mdi-scale-bathroom mdi-24px mr-2"></i>1 Bathrooms</li>-->
                        <!--                                </ul>-->
                        <!--                                <p class="text-white d-block mb-0">Rent <span class="text-success">$1890</span> /Night</p>-->
                        <!--                            </div>-->
                        <div class="read_more bg-primary text-center rounded-circle">
                            <a href="javascript:void(0)" class="text-light d-block">
                                <i-feather name="chevron-right" class="fea icon-sm title-dark"></i-feather>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!--end col-->

            <div class="col-lg-4 col-md-6 mt-4 pt-2">
                <div class="card work-container work-modern rounded border-0 overflow-hidden">
                    <div class="card-body p-0">
                        <img src="assets/gallery/8.jpg" class="img-fluid rounded" alt="work-image">
                        <div class="overlay-work"></div>
                        <!--                            <div class="content">-->
                        <!--                                <a href="javascript:void(0)" class="title text-white pb-2 border-bottom">Super Premium Room</a>-->
                        <!--                                <ul class="post-meta mb-0 mt-2 text-white list-unstyled">-->
                        <!--                                    <li class="list-inline-item mr-3"><i class="mdi mdi-bed-empty mdi-24px mr-2"></i>1 Bed</li>-->
                        <!--                                    <li class="list-inline-item"><i class="mdi mdi-scale-bathroom mdi-24px mr-2"></i>1 Bathrooms</li>-->
                        <!--                                </ul>-->
                        <!--                                <p class="text-white d-block mb-0">Rent <span class="text-success">$2050</span> /Night</p>-->
                        <!--                            </div>-->
                        <div class="read_more bg-primary text-center rounded-circle">
                            <a href="javascript:void(0)" class="text-light d-block">
                                <i-feather name="chevron-right" class="fea icon-sm title-dark"></i-feather>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!--end col-->

            <div class="col-lg-4 col-md-6 mt-4 pt-2">
                <div class="card work-container work-modern rounded border-0 overflow-hidden">
                    <div class="card-body p-0">
                        <img src="assets/gallery/9.jpg" class="img-fluid rounded" alt="work-image">
                        <div class="overlay-work"></div>
                        <!--                            <div class="content">-->
                        <!--                                <a href="javascript:void(0)" class="title text-white pb-2 border-bottom">Premium Big Room</a>-->
                        <!--                                <ul class="post-meta mb-0 mt-2 text-white list-unstyled">-->
                        <!--                                    <li class="list-inline-item mr-3"><i class="mdi mdi-bed-empty mdi-24px mr-2"></i>1 Bed</li>-->
                        <!--                                    <li class="list-inline-item"><i class="mdi mdi-scale-bathroom mdi-24px mr-2"></i>1 Bathrooms</li>-->
                        <!--                                </ul>-->
                        <!--                                <p class="text-white d-block mb-0">Rent <span class="text-success">$2500</span> /Night</p>-->
                        <!--                            </div>-->
                        <div class="read_more bg-primary text-center rounded-circle">
                            <a href="javascript:void(0)" class="text-light d-block">
                                <i-feather name="chevron-right" class="fea icon-sm title-dark"></i-feather>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->

        <div class="row justify-content-center">

            <!--end col-->
        </div>
        <!--end row-->
    </div>
    <!--end container-->
</section>
<!--end section-->


<section class="section bg-light">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 text-center">
                <div class="section-title">
                    <h4 class="title font-weight-bold mb-4">Everyone Needs Travel. <br> Want to Break Free for a
                        While
                    </h4>
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>
    <!--end container-->

    <div class="container mt-100 mt-60">
        <div class="row align-items-center">
            <div class="col-lg-5 col-md-6">
                <div class="card blog rounded border-0 shadow overflow-hidden">
                    <div class="position-relative">
                        <img src="assets/images/travel/1.jpg" class="card-img-top" alt="...">
                        <div class="overlay rounded-top bg-dark"></div>
                    </div>
                    <div class="card-body content">
                        <!--                            <h5><a href="javascript:void(0)" class="card-title title text-dark">Conversations, Feedback,-->
                        <!--                                Recognition</a></h5>-->
                        <!--                            <div class="post-meta d-flex justify-content-between mt-3">-->
                        <!--                                <ul class="list-unstyled mb-0">-->
                        <!--                                    <li class="list-inline-item mr-2 mb-0"><a href="javascript:void(0)"-->
                        <!--                                                                              class="text-muted like"><i-->
                        <!--                                            class="mdi mdi-heart-outline mr-1"></i>33</a></li>-->
                        <!--                                    <li class="list-inline-item"><a href="javascript:void(0)"-->
                        <!--                                                                    class="text-muted comments"><i-->
                        <!--                                            class="mdi mdi-comment-outline mr-1"></i>08</a></li>-->
                        <!--                                </ul>-->
                        <!--                                <a routerLink="/page-blog-detail" class="text-muted readmore">Read More <i-->
                        <!--                                        class="mdi mdi-chevron-right"></i></a>-->
                        <!--                            </div>-->
                    </div>
                    <div class="author">
                    </div>
                </div>
            </div>
            <!--end col-->

            <div class="col-lg-7 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                <div class="section-title ml-lg-4">
                    <h4 class="title mb-4">Experience Luxury & <br> Find Your Base</h4>
                    <!--                    <p class="text-muted">You can combine all the 3R Travels templates into a single one, you can-->
                    <!--                        take a-->
                    <!--                        component-->
                    <!--                        from the Application theme and use it in the Website.</p>-->
                    <!--                    <ul class="list-unstyled text-muted">-->
                    <!--                        <li class="mb-0"><span class="text-primary h5 mr-2"><i-->
                    <!--                                class="uim uim-check-circle"></i></span>Digital-->
                    <!--                            Marketing Solutions for Tomorrow-->
                    <!--                        </li>-->
                    <!--                        <li class="mb-0"><span class="text-primary h5 mr-2"><i-->
                    <!--                                class="uim uim-check-circle"></i></span>Our-->
                    <!--                            Talented-->
                    <!--                            & Experienced Marketing Agency-->
                    <!--                        </li>-->
                    <!--                        <li class="mb-0"><span class="text-primary h5 mr-2"><i-->
                    <!--                                class="uim uim-check-circle"></i></span>Create-->
                    <!--                            your-->
                    <!--                            own skin to match your brand-->
                    <!--                        </li>-->
                    <!--                    </ul>-->
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>
    <!--end container-->

    <div class="container mt-100 mt-60">
        <div class="row align-items-center">
            <div class="col-lg-5 col-md-6 order-1 order-md-2">
                <img src="assets/3r/MY5ZwP4OK.jpg" class="img-fluid rounded shadow-md" alt="">
            </div>
            <!--end col-->

            <div class="col-lg-7 col-md-6 order-2 order-md-1 mt-4 mt-sm-0 pt-2 pt-sm-0">
                <div class="section-title mr-lg-5">
                    <h4 class="title mb-4">100% Money back <br> Guarantee if You Cancel</h4>
                    <!--                    <p class="text-muted">You can combine all the 3R Travels templates into a single one, you can-->
                    <!--                        take a-->
                    <!--                        component-->
                    <!--                        from the Application theme and use it in the Website.</p>-->
                    <div class="faq-content mt-4 pt-2">
                        <!--                            <ngb-accordion #acc="ngbAccordion" activeIds="ngb-panel-0" closeOthers="true">-->
                        <!--                                <ngb-panel cardClass="border-0 rounded shadow mb-2">-->
                        <!--                                    <ng-template ngbPanelTitle>-->
                        <!--                                        <div class="border-0 bg-light" id="headingtwo">-->
                        <!--                                            <h6 class="title mb-0 text-dark"> How our <span-->
                        <!--                                                    class="text-primary">3R Travels</span> work ?-->
                        <!--                                            </h6>-->
                        <!--                                        </div>-->
                        <!--                                    </ng-template>-->
                        <!--                                    <ng-template ngbPanelContent>-->
                        <!--                                        <p class="text-muted mb-0 faq-ans">There are many variations of passages of-->
                        <!--                                            Lorem-->
                        <!--                                            Ipsum available,-->
                        <!--                                            but-->
                        <!--                                            the majority have suffered alteration in some form.</p>-->
                        <!--                                    </ng-template>-->
                        <!--                                </ngb-panel>-->
                        <!--                                <ngb-panel cardClass="border-0 rounded shadow mb-2">-->
                        <!--                                    <ng-template ngbPanelTitle>-->
                        <!--                                        <div class="border-0 bg-light" >-->
                        <!--                                            <h6 class="title mb-0 text-dark"> What is the main process open account-->
                        <!--                                                ? </h6>-->
                        <!--                                        </div>-->
                        <!--                                    </ng-template>-->
                        <!--                                    <ng-template ngbPanelContent>-->
                        <!--                                        <p class="text-muted mb-0 faq-ans">There are many variations of passages of-->
                        <!--                                            Lorem-->
                        <!--                                            Ipsum available,-->
                        <!--                                            but-->
                        <!--                                            the majority have suffered alteration in some form.</p>-->
                        <!--                                    </ng-template>-->
                        <!--                                </ngb-panel>-->
                        <!--                                <ngb-panel cardClass="border-0 rounded shadow mb-2">-->
                        <!--                                    <ng-template ngbPanelTitle>-->
                        <!--                                        <div class="border-0 bg-light" >-->
                        <!--                                            <h6 class="title mb-0 text-dark"> How to make unlimited data entry ? </h6>-->
                        <!--                                        </div>-->
                        <!--                                    </ng-template>-->
                        <!--                                    <ng-template ngbPanelContent>-->
                        <!--                                        <p class="text-muted mb-0 faq-ans">There are many variations of passages of-->
                        <!--                                            Lorem-->
                        <!--                                            Ipsum available,-->
                        <!--                                            but-->
                        <!--                                            the majority have suffered alteration in some form.</p>-->
                        <!--                                    </ng-template>-->
                        <!--                                </ngb-panel>-->
                        <!--                            </ngb-accordion>-->

                    </div>
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>
    <!--end container-->


    <div class="container mt-100 mt-60">
        <div class="row align-items-center">
            <div class="col-lg-5 col-md-6">
                <img src="assets/images/travel/2.jpg" class="img-fluid rounded shadow-md" alt="">
            </div>
            <!--end col-->

            <div class="col-lg-7 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                <div class="section-title ml-lg-4">
                    <h4 class="title mb-4">About us</h4>
                    <p class="text-muted">Growing from strength to strength, the 3R Travels team always looks to provide
                        our valued clients more than promised. The 3R team is reachable 24 hours 7 days a week.</p>
                    <!--                    <ul class="list-unstyled text-muted">-->
                    <!--                        <li class="mb-0"><span class="text-primary h5 mr-2"><i class="uim uim-check-circle"></i></span>Digital-->
                    <!--                            Marketing Solutions for Tomorrow-->
                    <!--                        </li>-->
                    <!--                        <li class="mb-0"><span class="text-primary h5 mr-2"><i class="uim uim-check-circle"></i></span>Our-->
                    <!--                            Talented-->
                    <!--                            & Experienced Marketing Agency-->
                    <!--                        </li>-->
                    <!--                        <li class="mb-0"><span class="text-primary h5 mr-2"><i class="uim uim-check-circle"></i></span>Create-->
                    <!--                            your-->
                    <!--                            own skin to match your brand-->
                    <!--                        </li>-->
                    <!--                    </ul>-->
                    <a href="javascript:void(0)" routerLink="/page-aboutus" class="btn btn-primary">See more
                        <i-feather name="arrow-right" class="fea icon-sm"></i-feather>
                    </a>
                </div>
            </div>
            <!--end col-->

        </div>
        <!--end row-->
    </div>
    <!--end container-->

    <div class="container mt-100 mt-60">
        <div class="row justify-content-center">
            <div class="col-12 text-center">
                <div class="section-title mb-4 pb-2">
                    <h4 class="title mb-4">Whats Our Clients Said About <span class="text-primary">3R Travels</span>
                    </h4>
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->

        <div class="row justify-content-center">
            <div class="col-lg-12 mt-4">
                <owl-carousel-o id="customer-testi" [options]="testiOptions">
                    <ng-template carouselSlide *ngFor="let r of review">
                        <div class="media customer-testi m-2">
                            <img src="assets/images/user/user-3331257__340.png"
                                 class="avatar avatar-small mr-3 rounded shadow"
                                 alt="">
                            <div class="media-body content p-3 shadow rounded bg-white position-relative">
                                <ul class="list-unstyled mb-0">
                                    <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                                    <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                                    <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                                    <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                                    <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>
                                </ul>
                                <p class="text-muted mt-2">"{{r.review}} "</p>
                                <h6 class="text-primary">{{r.clientName}} </h6>
                            </div>
                        </div>
                    </ng-template>
                </owl-carousel-o>
                <!-- </div> -->
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>
    <!--end container-->
    <div class="row mt-5 pt-md-4 justify-content-center">
        <div class="col-1"></div>
        <div class="col-4">

            <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Ftravels3R&tabs=timeline&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                    width="340" height="500" style="border:none;overflow:hidden" scrolling="no" frameborder="0"
                    allowfullscreen="true"
                    allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
        </div>
        <div class="col-4 text-center">
            <div class="section-title">
                <h4 class="title mb-4">Have Question ? Get in touch!</h4>
                <a routerLink="/page-contact" class="btn btn-primary mt-4"><i class="mdi mdi-phone"></i> Contact
                    us</a>
            </div>
        </div>
        <div class="col-1"></div>
        <!--end col-->
    </div>
    <!--end row-->
</section>
<!--end section-->

<!-- Back to top -->
<a href="javascript: void(0);" class="btn btn-icon btn-soft-primary back-to-top" id="back-to-top"
   [ngxScrollTo]="'#home'">
    <i-feather name="arrow-up" class="icons"></i-feather>
</a>
<!-- Back to top -->


<!-- Modal Content Start -->
<ng-template #content let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="modal-basic-title">Package details</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="bg-white p-3 rounded box-shadow">
            <h4>{{details.packageName}}</h4>
            <p class="text-secondary">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Atque culpa debitis
                dolorum est ex id iure labore modi nesciunt numquam odio omnis pariatur qui saepe vitae, voluptate,
                voluptatem voluptatibus voluptatum!</p>
            <p class="text-primary">{{details.packageStartDate}}  to  {{details.packageEndDate}}</p>
            <p>{{details.noOfDays}} Days</p>
            <h6>itenary</h6>
            <p class="text-secondary" *ngFor="let d of details.itenary">{{d.description}}</p>
            <br>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Close</button>
    </div>
</ng-template>
<!-- Modal Content End -->
